"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _PreviewScreenshot = _interopRequireDefault(require("../PreviewScreenshot"));

var _OverallResultSection = _interopRequireDefault(require("../result/OverallResultSection"));

var _TrialConstants = require("../../constants/TrialConstants");

var _Preview = require("../../selectors/Preview");

var _Urls = require("../../util/Urls");

var getLangKey = function getLangKey() {
  return window.I18N_MANUAL_LANG;
};

var LangButton = function LangButton() {
  var lang = getLangKey();
  var parsedUtmParams = (0, _Urls.parseUtmParams)();

  if (lang !== 'en') {
    return _react.default.createElement("a", {
      className: "button lg",
      href: _TrialConstants.LanguageCTALinks[lang] + "&" + parsedUtmParams,
      target: "_blank",
      rel: "noopener noreferrer"
    }, _react.default.createElement(_FormattedMessage.default, {
      message: "trialBanner.ctaButtonGetGuide"
    }));
  }

  return _react.default.createElement("a", {
    className: "button lg",
    href: _TrialConstants.CTA_OVERALL_BANNER_LINK + "&" + parsedUtmParams,
    target: "_blank",
    rel: "noopener noreferrer"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "trialBanner.ctaButtonCourse"
  }));
};

var _default = function _default(_ref) {
  var websiteGrade = _ref.websiteGrade;

  var _useSelector = (0, _reactRedux.useSelector)(_Preview.getDesktopPreview, _reactRedux.shallowEqual),
      url = _useSelector.url,
      error = _useSelector.error;

  return _react.default.createElement("div", {
    className: "full-page-centered overall-page",
    id: "overall"
  }, _react.default.createElement("div", null, _react.default.createElement("div", {
    className: "wsg-container"
  }, _react.default.createElement("div", {
    className: "bg-gradient"
  }), _react.default.createElement(_OverallResultSection.default, {
    websiteGrade: websiteGrade
  }), _react.default.createElement(LangButton, null), _react.default.createElement(_PreviewScreenshot.default, {
    previewUrl: url,
    error: error
  }))));
};

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/pages/OverallPage.js
// module id = 303
// module chunks = 0